//框架里面的公共方法
import store from '@/store/index.js'
export const sysframe = {
    getSideBarLeft(){
        let left= 64
        if(store.getters.sidebar.opened){
            left= 270
        }else{
            left= 64
        }
        return (left+'px')
    },
}